import React, { useState, useEffect, useRef } from "react";
import MaterialTable from "material-table";
import Grid from "@mui/material/Grid";
import { Form } from "react-bootstrap";
import { Box, Button, Table, Input } from "@mui/material";
import Moment from "moment";
import jsPDF from "jspdf";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import "jspdf-autotable";
import moment from "moment";
import axios from "../../Uri";
import { GetAllBuildings } from "./Urls";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { DownloadTableExcel } from "react-export-table-to-excel";
import MDBox from "components/MDBox";
const FilterData = () => {
  const [startDate, setStartDate] = useState("");
  const [payment, setPayment] = useState([]);
  const [endDate, setEndDate] = useState("");
  const [selected, setSelected] = React.useState("");
  const [building, setBuilding] = React.useState([]);
  const [buildingId, setbuildingId] = React.useState(null);
  console.log(buildingId);
  console.log(building);
  const tableRef = useRef(null);
  const GetDataSheet = () => {
    axios
      .get(
        `/payment/byDate/${buildingId}?startDate=${startDate}&endDate=${endDate}`
      )
      .then((response) => {
        console.log(response);
        console.log(response.data);
        setPayment(response.data);
        // if (response.data.status == true || response.data.data != null) {
        // setPayment(response.data);
        //   console.log(response.data);
        // }
        // else if (response.data.status == false && response.data.data == null) {
        //    console.log("No Records Found");
        //     //   toast.warning(" No Records Found");
        // }
        //?startDate=2022-09-02&endDate=2022-09-08
        //?startDate=${startDate}&endDate=${endDate}
      })
      .catch((error) => {
        console.log(" No Records Found", error);
      });
    // console.log(response.data);
  };
  useEffect(() => {
    GetAllBuildings()
      .then((res) => {
        setBuilding(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong🤦‍♂️");
      });
  }, []);
  useEffect(() => {
    GetDataSheet();
  }, []);
  console.log(payment);
  return (
    <Grid item container spacing={1}>
      <Grid item lg={12} md={6} xs={12}>
        <label value="Select Building: ">Select Building: </label>
        <Select
          sx={{ minHeight: 44 }}
          style={{ width: "30%", height: "10%" }}
          value={selected}
          name="building"
          IconComponent={() => <ArrowDropDownIcon />}
        >
          {building.map((post) => {
            return (
              <MenuItem
                value={post.buildingName}
                onClick={async () => {
                  setSelected(post.buildingName);
                  console.log(post.buildingId);
                  setbuildingId(post.buildingId);
                }}
              >
                {" "}
                {post.buildingName}{" "}
              </MenuItem>
            );
          })}
        </Select>
        <MDBox
          style={{ padding: "20px", margin: "18px", border: "2px solid maroon",borderRadius:'10px' }}
        >
          <strong>
            {" "}
            <button
              style={{
                fontSize: "17px",
                color: "white",
                border: "2px solid white",
                borderRadius: "4px",
                margin: "22px",
                background: "#419BEF",
                width: "160px",
                height: "30px",
              }}
            >
              Select From Date
            </button>
          </strong>
          <Input
            style={{
              border: "2px solid maroon",
              borderRadius: "3px",
              margin: "4px",
            }}
            type="date"
            onChange={(e) => setStartDate(e.target.value)}
          />
          <strong>
            {" "}
            <button
              style={{
                fontSize: "17px",
                color: "white",
                border: "2px solid white",
                borderRadius: "4px",
                margin: "22px",
                background: "#419BEF",
                width: "160px",
                height: "30px",
              }}
            >
              Select To Date
            </button>
          </strong>
          <Input
            style={{
              border: "2px solid maroon",
              borderRadius: "3px",
              margin: "4px",
            }}
            type="date"
            onChange={(e) => setEndDate(e.target.value)}
          />
          <Button
            type="submit"
            onClick={GetDataSheet}
            style={{
              background: "blue",
              color: "white",
              marginRight: "6px",
              marginLeft: "18px",
              marginTop: "2px",
              padding: "12px",
              width: "120px",
            }}
          >
            Filter
          </Button>
          <DownloadTableExcel
            filename="Transactions"
            sheet="users"
            currentTableRef={tableRef.current}
          >
            <Button
              style={{
                background: "#419BEF",
                color: "white",
                marginLeft: "18px",
                margingTop: "12px",
                padding: "12px",
                width: "190px",
              }}
            >
              Download Excel
            </Button>
          </DownloadTableExcel>
        </MDBox>
      </Grid>
      <Grid item lg={12} md={6} xs={12}>
        <div style={{ border: "none" }}>
          <Table striped bordered hover className="table" ref={tableRef} stickyHeader>
            <thead color="white" align="left" height="50px" border="2px solid white" marginLeft="6px">
              {/* <tr className="tr" > */}
              <th color="white" aligh="left" className="header" scope="col" marginLeft="6px">
                Transaction Date
              </th>
              <th color="white" className="header" scope="col">
                Transaction Id
              </th>
              <th color="white" className="header" scope="col">
                GuestName
              </th>
              <th color="white" className="header" scope="col">
                Amount
              </th>
              <th color="white" className="header" scope="col" marginLeft="6px">
                BuildingName
              </th>
              <th color="white" className="header" scope="col" marginLeft="6px">
                BedId
              </th>
              <th color="white" className="header" scope="col">
                occupancyType
              </th>
            </thead>
            {payment.map((student, index) => (
              <tr data-index={index}>

                <td>{student.transactionDate}</td>
                <td>{student.transactionId}</td>
                <td>{student.guestName}</td>
                <td>{student.amountPaid}</td>
                <td>{student.buildingName}</td>
                <td>{student.bedId}</td>
                <td>{student.occupancyType}</td>
              </tr>
            ))}
          </Table>
        </div>
      </Grid>
    </Grid>
  );
};
export default FilterData;